import { epicRequest, reducersMerge, reduxCreator, reduxFetchCreator, serverResponse } from 'app'

import type { TeamSchema } from 'teams'

export type ListFilter = {
  categoryId?: string

  key?: string // unique search key
  disciplineId?: string
  genderId?: string
  page?: number
  per_page?: number
  search: string
  tournamentId?: string
  userId?: string
}

const getInitialState = () =>
  serverResponse<TeamSchema[]>({
    key: '',
    data: [],
  })

const list = reduxFetchCreator<'teamsList', ListFilter, ReturnType<typeof getInitialState>>(
  'teamsList',
  getInitialState(),
  {
    start: (state, action) => ({
      ...state,
      key: action.payload.key,
    }),
  },
)

const teamsListEpic = epicRequest({
  actionType: list.actions.teamsList.type,
  debounce: 700,
  errorAction: list.actions.teamsListError,
  fulfilledAction: list.actions.teamsListFulfilled,
  request: (action: { payload: Record<string, string> }) => {
    const search = new URLSearchParams(action.payload)

    return {
      method: 'get',
      url: `sports/soccer/teams?${search.toString()}`,
    }
  },
  untilTypes: list.actions.teamsListCancel.type,
})

const clear = reduxCreator<'teamsListClear', undefined, ReturnType<typeof getInitialState>>(
  'teamsListClear',
  getInitialState(),
  () => getInitialState(),
)

export const actions = {
  ...list.actions,
  teamsListClear: clear.teamsListClear,
}

export const epics = [teamsListEpic]

export const reducer = reducersMerge(clear.reducer, list.reducer) as typeof list.reducer
